module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/share-screen-6bddb81c.svg";